"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var contentViewLoad_1 = require("./contentViewLoad");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.ContentViewLoadEventNames.ContentViewLoad] = contentViewLoad_1.contentViewLoad,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
